import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { Modal as SemanticUiModal, ModalProps as SemanticUiModalProps } from 'semantic-ui-react';
import Button from '../Button';
import ErrorContainer from '../ErrorContainer';
import Icon, { ICONS } from '../Icon';
import Loader from '../Loader';
import styles from './Modal.module.scss';
import { ModalWidth } from './ModalWidth.enum';

const cx = classNames.bind(styles);

interface ModalProps extends SemanticUiModalProps {
  children: ReactElement;
  onClose: () => void;
  open: boolean;
  headerTitle?: string | ReactElement;
  className?: string;
  dataTestId?: string;
  footer?: ReactElement;
  width?: ModalWidth;
  error?: string;
  isLoading?: boolean;
  isScrollable?: boolean;
  closeOnButtonClick?: boolean;
}

const Modal = ({
  children,
  className,
  dataTestId,
  footer,
  headerTitle,
  onClose,
  open,
  width,
  error,
  isLoading,
  isScrollable = true,
  closeOnButtonClick = true,
  ...rest
}: ModalProps): React.ReactElement => {
  return (
    <SemanticUiModal
      className={cx(className, { [`${width}`]: width })}
      closeOnDimmerClick
      onClose={onClose}
      open={open}
      data-testid={dataTestId}
      {...rest}
    >
      {headerTitle && (
        <SemanticUiModal.Header className={cx('header')}>
          <h3 className={cx('title')}>{headerTitle}</h3>
          <Button
            className={cx('close-btn')}
            data-testid="modal-close"
            onClick={onClose}
            disabled={!closeOnButtonClick}
          >
            <Icon name={ICONS.Times} />
          </Button>
        </SemanticUiModal.Header>
      )}
      {error && <ErrorContainer error={error} />}
      <SemanticUiModal.Content className={cx('content')} scrolling={isScrollable}>
        {isLoading ? (
          <div className={cx('loader-wrapper')}>
            <Loader position="center" />
          </div>
        ) : (
          children
        )}
      </SemanticUiModal.Content>
      {footer && <SemanticUiModal.Actions className={cx('footer')}>{footer}</SemanticUiModal.Actions>}
    </SemanticUiModal>
  );
};

export default Modal;
